export function isChunkLoadError(err: unknown): boolean {
  if (!err) return false;

  const name = (err as { name?: unknown })?.name;
  if (typeof name === 'string' && name === 'ChunkLoadError') return true;

  const message = (err as { message?: unknown })?.message;
  if (typeof message !== 'string') return false;

  return (
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Loading CSS chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /import\(\) failed/i.test(message)
  );
}
